import type { JSX } from 'react'
import type { OverlayLayoutColors } from './OverlayLayout.h'

import { OverlayLayoutStyled } from './OverlayLayout.styled'

export interface IOverlayLayoutProps {
  overlayEnabled?: boolean
  overlayWidth?: string
  overlayHeight?: string
  overlayHorizontalColor?: OverlayLayoutColors
  overlayVerticalColor?: OverlayLayoutColors
  overlayFullColor?: OverlayLayoutColors
}

export const OverlayLayout = ({
  overlayEnabled = false,
  overlayWidth = '',
  overlayHeight = '',
  overlayHorizontalColor,
  overlayVerticalColor,
  overlayFullColor,
}: IOverlayLayoutProps): JSX.Element => (
  <OverlayLayoutStyled
    overlayEnabled={overlayEnabled}
    overlayWidth={overlayWidth}
    overlayHeight={overlayHeight}
    overlayHorizontalColor={overlayHorizontalColor}
    overlayVerticalColor={overlayVerticalColor}
    overlayFullColor={overlayFullColor}
  />
)
